export interface Client {
  id: string;
  name: string;
  industry: { th: string; en: string };
  project: { th: string; en: string };
  logoUrl?: {
    th: string;
    en: string;
  } | string;
  website?: {
    th: string;
    en: string;
  } | string;
  description?: { th: string; en: string };
  startDate?: string;
  endDate?: string;
  status: 'active' | 'completed' | 'ongoing';
  darkLogo?: boolean; // logo is white/light → render on a dark tile
}

export const clients: Client[] = [
  {
    id: 'sansiri',
    name: 'Sansiri',
    industry: {
      th: 'อสังหาริมทรัพย์',
      en: 'Real Estate & Property'
    },
    project: {
      th: 'น้องแสนรู้ - AI Assistant',
      en: 'Sanroo - AI Assistant'
    },
    logoUrl: {
      th: 'https://sansiri-com-frontend.s3.ap-southeast-1.amazonaws.com/assets/img/logo-sansiri-black-th.svg',
      en: 'https://sansiri-com-frontend.s3.ap-southeast-1.amazonaws.com/assets/img/logo-sansiri-black-en.svg'
    },
    website: {
      th: 'https://www.sansiri.com/thai',
      en: 'https://www.sansiri.com/en'
    },
    description: {
      th: 'บริษัทอสังหาริมทรัพย์ชั้นนำของไทย ผู้พัฒนาโครงการที่อยู่อาศัยคุณภาพสูง',
      en: 'Leading real estate company in Thailand, developing high-quality residential projects'
    },
    startDate: '2019-04',
    status: 'completed'
  },
  {
    id: 'ocpb',
    name: 'OCPB (สคบ.)',
    industry: {
      th: 'หน่วยงานรัฐ · คุ้มครองผู้บริโภค',
      en: 'Government · Consumer Protection'
    },
    project: {
      th: 'พี่ปกป้อง — AI Assistant (rootBot)',
      en: 'Pokpong — AI Assistant (rootBot)'
    },
    logoUrl: require('../assets/rootbot/ocpb-logo.png'),
    description: {
      th: 'สำนักงานคณะกรรมการคุ้มครองผู้บริโภค',
      en: 'Office of the Consumer Protection Board'
    },
    status: 'completed'
  },
  {
    id: 'pdmo',
    name: 'PDMO (สบน.)',
    industry: {
      th: 'หน่วยงานรัฐ · บริหารหนี้สาธารณะ',
      en: 'Government · Public Debt'
    },
    project: {
      th: 'พี่วายุ — AI Assistant (rootBot)',
      en: 'Payu — AI Assistant (rootBot)'
    },
    logoUrl: require('../assets/rootbot/pdmo-logo.png'),
    description: {
      th: 'สำนักงานบริหารหนี้สาธารณะ',
      en: 'Public Debt Management Office'
    },
    status: 'completed'
  },
  {
    id: 'nia',
    name: 'NIA (สนช.)',
    industry: {
      th: 'หน่วยงานรัฐ · นวัตกรรม',
      en: 'Government · Innovation'
    },
    project: {
      th: 'AI ผู้ช่วยจัดการเอกสาร MOU (rootBot)',
      en: 'MOU Document AI Assistant (rootBot)'
    },
    logoUrl: require('../assets/rootbot/nia-logo.png'),
    darkLogo: true,
    description: {
      th: 'สำนักงานนวัตกรรมแห่งชาติ',
      en: 'National Innovation Agency'
    },
    status: 'completed'
  },
  {
    id: 'bundhaya',
    name: 'Bundhaya Speedboat',
    industry: {
      th: 'ท่องเที่ยว · เรือเร็ว',
      en: 'Travel · Speed Boat'
    },
    project: {
      th: 'Trip Assistant — จองเรือ omnichannel (rootBot)',
      en: 'Trip Assistant — omnichannel booking (rootBot)'
    },
    logoUrl: require('../assets/rootbot/bundhaya-logo.png'),
    website: 'https://v2.bundhayaspeedboat.com',
    description: {
      th: 'บริการเรือเร็วเส้นทางทะเลอันดามัน',
      en: 'Andaman speed-boat operator'
    },
    status: 'ongoing'
  }
];